// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/LeftCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleOutlinedSvg
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
export default React.forwardRef(LeftCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LeftCircleOutlined.js
// module id = 1397
// module chunks = 0